module.exports = __webpack_public_path__ + "media/large/list-my-home-130bc64d.jpg";